import type { OptionPriceOut } from '@/lib/api/types';

/**
 * The lowest delivered total among the presets.
 *
 * Every preset is printable now — one that does not stock the customer's page
 * size prints on the nearest sheet it does stock rather than refusing — so
 * there is nothing to exclude before comparing.
 */
export function cheapestSlug(options: readonly OptionPriceOut[]): string | null {
  if (options.length === 0) return null;
  return options.reduce((best, entry) =>
    entry.totals.total_paise < best.totals.total_paise ? entry : best,
  ).option.slug;
}
